import React from "react";

import Checkbox from "../CheckBox/Checkbox";
import styles from "./table.module.scss";

export interface Row {
  id: string;
  columns: Column[];
}

export interface Column {
  id: string;
  value: JSX.Element | string | number;
}

export interface TableProps {
  data: Row[];
  handleRowClick: (row: Row) => void;
  selected?: Row[];
  handleSelectAll?: () => void;
}

export const Table = ({ data, handleRowClick, selected, handleSelectAll }: TableProps) => {
  const checkable = !!selected;

  return (
    <table>
      <thead>
        <tr>
          {checkable && (
            <th>
              <Checkbox
                checked={data.every((row) => selected.find((selectedRow) => selectedRow.id === row.id))}
                onClick={handleSelectAll}
              />
            </th>
          )}
          {data[0]?.columns.map((column, index) => (
            <th key={index}>{column.id.toLocaleUpperCase()}</th>
          ))}
        </tr>
      </thead>
      <tbody className={styles.tableBody}>
        {data.map((row: any) => (
          <tr
            key={row.id}
            onClick={() => {
              handleRowClick(row);
            }}
          >
            {checkable && (
              <td>
                <Checkbox
                  checked={!!selected.find((selectedRow) => row.id === selectedRow.id)}
                  onClick={(e) => e.stopPropagation()} // Prevents row click from firing
                />
              </td>
            )}
            {row.columns.map((column: any, index: number) => (
              <td key={index}>{column.value}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
